import React, { useRef, useState, useEffect, useCallback } from 'react';
import { DropdownIcon, Price as PriceIcon } from 'components/Icons/Glyphs';
import Menu from 'components/Menu';

const Selected = ({ t, price }) => <span className="zt-nav"><PriceIcon />{price ? t('common:pricenumber', {price: Number(price)}) : '--'}</span>

export default React.forwardRef(({ name, items, placeholder, searchplaceholder, ticket, t, onChange, ...props }, selectRef) => {
    const [value, setValue] = useState('');
    const [active, setActive] = useState(false);
    const ref = useRef();

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setActive(false);
            if (props.onClose) {
                props.onClose();
            }
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });   

    const { price: ticketPrice } = ticket;

    const onSelect = useCallback(item => {
        setActive(false);
        onChange && onChange(item);
    }, [setActive, setValue, onChange]);

    return (
        <div className='zt-inputs--priceselect zt-inputs--priceselect--selected' ref={ref} >
            <select ref={selectRef} name={name} value={value} onChange={()=>null} >
                {items?.map(({ id, label }, key) => <option value={id} key={key}>{label}</option>)}
            </select>
            <button type="button" className={`zt-inputs--priceselect__button ${value ? 'zt-inputs--priceselect__button--selected' : ''} `} onClick={() => setActive(a => !a)}>
                <Selected {...{price:ticketPrice, t}} />
                <DropdownIcon className='zt-inputs--priceselect__button__icon'/>
            </button>
            { active && 
            <Menu items={items?.map(item => ({...item, label: `${item.label} (${item.type})`, icon: PriceIcon}))} className='zt-inputs--priceselect__menu' onSelect={item => onSelect(item)} />
            }
        </div>
    )
});